<template>
  <div>
    <b-modal size="xl" hide-footer v-model="modalLetter" class="w-100" title="CARTA">
      <b-row>
        <b-col md="12">
          <b-form-group label="Buscar la carta :">
            <b-form-input autofocus type="search" ref="search_letter" v-model="search_letter" @keyup="SearchLetter"></b-form-input>
            
          </b-form-group>
        </b-col>
        <b-col md="12">
          <div class="table-responsive mt-3">
            <table class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th width="5%"  class="text-center align-middle">#</th>
                  <th width="8%"  class="text-center align-middle">Código</th>
                  <th width="55%"  class="text-center align-middle">Nombre</th>
                  <th width="15%"  class="text-center align-middle">Categoria</th>
                  <th width="10%"  class="text-center align-middle">Cantidad</th>
                  <th width="7%"  class="text-center align-middle">Acciones</th>
                </tr>
              </thead>
              <tbody v-for="(item, it) in products" :key="it">
                <tr>
                  <td class="text-center">{{ it + 1 }}</td>
                  <td class="text-center">{{ item.code }}</td>
                  <td class="text-left">{{ item.name + (item.presentation.length == 0 ? '':' - '+item.presentation ) }}</td>
                  <td class="text-left">{{ item.category_name }}</td>
                  <td class="text-center">
                    <input type="number" step="any" value="1.00" v-model="item.quantity" class="form-control">
                  </td>
                  <td class="text-center">
                    <b-button type="button" @click="AddLetter(it)" variant="primary"><i class="fas fa-plus-square"></i></b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style>


</style>


<script>
const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState,mapActions } from "vuex";
import EventBus from "@/assets/js/EventBus";
import CodeToName from "@/assets/js/CodeToName";
export default {
  name: "ModalsProduct",
  data() {
    return {
        modalLetter:false,
        module:'Catering',
        role:0,
        search_letter:'',
        products: [],
    };
  },
  created (){
    
  },
  mounted () {
    EventBus.$on('ModalLetterShow', (role) => {
      this.modalLetter = true;
      this.role = role;
    });

  },
  methods: {
      SearchLetter,
      AddLetter,
      ...mapActions('Catering',['mLoadAddCateringDetail']),
  },
  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function AddLetter(index) {
    let quantity = this.products[index].quantity;
    let id_letter = this.products[index].id_letter;
    if (quantity.length == 0) {
      me.$notify({ group: 'alert', title: 'Sistema', text:'Ingrese una cantidad', type: 'error'})
      return false;
    }
    let me = this;
    let url = this.url_base + "letter/view/" + id_letter;
    axios({
      method: "GET",
      url: url,
      headers: { token: this.token, module: this.module, role: this.role},
    })
    .then(function (response) {
      if (response.data.status == 200) {
        let detail = {
          id_letter: response.data.result.letter.id_letter,
          code: response.data.result.letter.code,
          name: response.data.result.letter.name + (response.data.result.letter.presentation.length == 0 ? '': ' - '+ response.data.result.letter.presentation),
          category_name: response.data.result.letter.category_name,
          quantity: parseFloat(quantity).toFixed(2),
        }
        me.mLoadAddCateringDetail(detail);
        me.$notify({ group: 'alert', title: 'Sistema', text:'Se ha agregado el producto '+detail.name, type: 'success'})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });

   
}

//Buscar productos
function SearchLetter() {
  let me = this;
  let search = this.search_letter == "" ? "all" : this.search_letter;
  let url = this.url_base + "letter/search";
  let data = {
    search : search,
    type_stock : 1,
  };
  axios({
    method: "POST",
    url: url,
    data:data,
    headers: { token: this.token, module: this.module, role: this.role},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.products = response.data.result;
      } else {
        me.products = [];
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      
    });
}
</script>
